"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var usePrice_1 = require("./usePrice");
var useTotalFeatures = function (totalFeatures) {
    var _a = usePrice_1.default(totalFeatures), primaryTotalFeaturesPrices = _a.primaryPrice, secondaryTotalFeaturesPrices = _a.secondaryPrice;
    return [primaryTotalFeaturesPrices, secondaryTotalFeaturesPrices];
};
exports.default = useTotalFeatures;
